import React from 'react';
import styles from './index.module.scss';

const BackgroundPodheader = ({ data = {}, path = '' }) => {
  return (
    <div className={styles.backgroundPodheader}>
      <div className={styles.content}>{/* Только оболочка без контента */}</div>
    </div>
  );
};

export default BackgroundPodheader;
